import Tiled from "@frog/source/utility/integration/Tiled.js"
import { HealPlayerPartyScript, Dialogue, MoveUnit, MoveEncounterScript, EscapeScript, SpawnUnitsScript } from "@frog/source/data/plotscripts.js"
import * as Plotscripts from "@frog/source/data/plotscripts.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/admin/Navigation.js"

const tiledWorld = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/tileset.json"),
})

export default {
    "slug": "2",
    "hasPreparePhase": false,
    "startingEncounter": "1",

    "decorations": {
        "hasSnow": true,
    },

    "stage": {
        "image": require("./environment.png"),
        "world": tiledWorld,
        "units": require("./units.json"),
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    Plotscripts.SpawnPlayerPartyScript(),
                    {"func": () => Audiomix.trigger("Ember:Music:Combat")},
                    {
                        "type": "chapter start",
                        "data": [
                            "Fen and fog,",
                            "Moor and mist,",
                            "No begging can hold their stay.",
                            "Winter falls.",
                        ]
                    },
                ]
            },
            {
                "type": "turn:every:end",
                "events": [
                    Plotscripts.SlowDeath(),
                ]
            },
            {
                "type": "defeat-all-units-of-affiliation", "affiliation": "good",
                "events": [
                    {"type": "chapter failure"},
                    {"func": () => Navigation.go("/games/ember")},
                ]
            },
            {
                "encounterKey": 1,
                "type": "defeat-all-units-of-affiliation", "affiliation": "bad",
                "events": [
                    Plotscripts.SlowDeath(),
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 2}),
                ]
            },
            {
                "encounterKey": 2,
                "type": "defeat-all-units-of-affiliation", "affiliation": "bad",
                "events": [
                    Plotscripts.SlowDeath(),
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 3}),
                    {"func": () => Audiomix.trigger("Music:Combat:stealth-winter-boss")},
                ]
            },
            {
                "encounterKey": 3,
                "type": "defeat-all-units-of-affiliation", "affiliation": "bad",
                "events": [
                    Plotscripts.SlowDeath(),
                    // Plotscripts.UpdatePlayerPartyScript(),
                    {"func": () => Audiomix.trigger("Ember:Music:Victory")},
                    {"type": "chapter success"},
                    {"func": () => Navigation.go("/games/ember")},
                ]
            },
        ]
    },
}
